
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/category/[categoryName]",
      function () {
        return require("private-next-pages/category/[categoryName].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/category/[categoryName]"])
      });
    }
  